var map = {
	"./about-us-banner-cn.webp": 1915,
	"./about-us-banner.webp": 375,
	"./banner-01.jpg": 1916,
	"./banner-slot.jpg": 1917,
	"./bet-and-earn-banner-cn.webp": 1918,
	"./bet-and-earn-banner-indon.webp": 1919,
	"./bet-and-earn-banner-ms.webp": 1920,
	"./bet-and-earn-banner.webp": 1921,
	"./check-in-banner-cn.webp": 1922,
	"./check-in-banner-id.webp": 1923,
	"./check-in-banner-ms.webp": 1924,
	"./check-in-banner.webp": 1925,
	"./cny_2024-bm.webp": 1926,
	"./cny_2024-cn.webp": 1927,
	"./cny_2024.webp": 1928,
	"./epl-banner-cn.webp": 1929,
	"./epl-banner-indo.webp": 1930,
	"./epl-banner-ms.webp": 1931,
	"./epl-banner.webp": 1932,
	"./lb-m-banner-cn.webp": 1933,
	"./lb-m-banner.webp": 1934,
	"./leaderboard-banner-cn.webp": 1935,
	"./leaderboard-banner.webp": 1936,
	"./lottery-banner.webp": 1937,
	"./lucky-spin-banner-cn.webp": 1938,
	"./lucky-spin-banner-ms.webp": 1939,
	"./lucky-spin-banner.webp": 1940,
	"./p2p-banner.webp": 1941,
	"./premier-league-banner-cn.webp": 1942,
	"./premier-league-banner.webp": 1943,
	"./promo-vip-banner-cn.webp": 1944,
	"./promo-vip-banner.webp": 1945,
	"./promos-banner-cn.webp": 1946,
	"./promos-banner-indon.webp": 1947,
	"./promos-banner-ms.webp": 1948,
	"./promos-banner.webp": 1949,
	"./promos-detail-banner.jpg": 1950,
	"./side-bar-banner.jpg": 1951,
	"./vip-banner-cn.webp": 1952,
	"./vip-banner-id.webp": 1953,
	"./vip-banner-mobile.webp": 1954,
	"./vip-banner-ms.webp": 1955,
	"./vip-banner.webp": 1956,
	"./winner-leaderboard-banner-cn.webp": 1957,
	"./winner-leaderboard-banner.webp": 1958,
	"./world-cup-banner-cn.webp": 1959,
	"./world-cup-banner.webp": 1960,
	"./world-cup-two-banner-cn.webp": 1961,
	"./world-cup-two-banner.webp": 1962,
	"./xmas_2023-bm.jpg": 1963,
	"./xmas_2023-cn.jpg": 1964,
	"./xmas_2023-id.jpg": 1965,
	"./xmas_2023.jpg": 1966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;